import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    container: {
        height: '200px'
    }
}));

export default function Loading() {

    const classes = useStyles();

    return (
        <Grid container alignItems="center" justify="center" className={classes.container}>
            <CircularProgress />
        </Grid>
    )
}
